<template>
  <div class="exit-effect":style="{height: collapse ? '46px': ''}">
    <div class="exit-effect-header" @click="collapse = !collapse">
      <span>出场动画</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>
    <div class="exit-effect-content">
      <div v-for="(item, key) in exitArr" v-if="item.show">
        <div :class="{active: type === item.type, 'disable': item.disable, 'effect-select': true}" @click="setEffect($event, item, key)">
          <i class="is-short" :class="{[`icon-${item.alias}-anim`]: true}"></i>
        </div>
        <span class="effect-name">{{item.text}}</span>
      </div>
    </div>
    <div class="exit-effct-footer">
      <div class="radios" v-if="type === 'Slide'">
        <div class="radios__title">
          动画速度
        </div>
        <ul class="radios__list">
          <li
            class="radios__item"
            v-for="(item, key) in easingList"
            :class="{active: item.active}"
            :key="key"
            @click="setEasing(item)"
          >
            <i></i>
            <span>{{item.text}}</span>
          </li>
        </ul>
      </div>
      <div class="list" v-if="type==='Slide' || type === 'Smear'">
        <div class="list__title">
          动画方向
        </div>
        <ul class="list__items">
          <li
            class="list__item"
            :class="{active: item.active}"
            v-for="(item, index) in showList"
            :key="index"
            @click="selectEffect(item)"
          >
            <div class="list__figure" :class="{[`icon-wrapper-${item.icon || item.to}`]: true}">
              <i class="icon" :class="{[`icon-effect-${item.icon || item.to}`]: true, 'is-out': true}"></i>
            </div>
            <div class="list__caption">{{item.text}}</div>
          </li>
        </ul>
      </div>
      <div :class="['hand', {'disable': !hasHand}]" @click="showHand">
        <i class="icon-set-hand"></i>
        <span>添加出场手势</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    },
    exitArr: {
      type: Array,
      required: true,
      default: []
    },
    exitCode: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      collapse: false,
      type: '',
      easingList: [
        {type: 'easeIn', text: '加速', active: false, num: 1, alias: 'easeOutExpo'},
        {type: 'easeOut', text: '减速', active: false, num: 2, alias: 'easeOutQuint'},
        {type: 'linear', text: '匀速', active: false, num: 0, alias: 'linear'}
      ],
      showList: [],
      hasHand: false,
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if(this.exitCode === 'UpOut' || this.exitCode === 'RightOut' || this.exitCode === 'DownOut' || this.exitCode === 'LeftOut') {
        this.type = 'Slide';
        this.hasHand = true;
      } else {
        this.type = this.exitCode;
        this.hasHand = false;
      }
      let exitAnim = this.SelectSprites_Msg[0].effect.exitAnim
      this.initShowList(this.type, exitAnim);
    },
    initShowList(type, exitAnim) {
      if(type === 'Slide') {
        let easing = exitAnim.easing;
        this.showList = [
          {text: '左移出', long: '向左移出', type: 'LeftOut', to: 'left', direction: '', active: false},
          {text: '右移出', long: '向右移出', type: 'RightOut', to: 'right', direction: '', active: false},
          {text: '上移出', long: '向上移出', type: 'UpOut', to: 'up', direction: '', active: false},
          {text: '下移出', long: '向下移出', type: 'DownOut', to: 'down', direction: '', active: false}
        ]
        this.easingList.forEach((item) => {
          if (item.alias === easing || item.num === easing) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
        this.showList.forEach(item => {
          if(exitAnim.type === item.type) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
      } else if(type === 'Smear') {
        let exitDire = exitAnim.direction || 'w';
        this.showList = [
          {text: '左擦除', long: '向左擦除', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '右擦除', long: '向右擦除', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '上擦除', long: '向上擦除', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'},
          {text: '下擦除', long: '向下擦除', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'}
        ];
        this.showList.forEach((item) => {
          if (item.direction === exitDire) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
      }
    },
    setEffect(e, item, key) {
      if(item.active) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let {start, end} = s.effect.exitAnim;
        undoData.reData.push({
          id: s.id,
          data: {
            exitAnim: {
              type: s.effect.exitAnim.type,
              start: start,
              end: end
            }
          }
        })
        let code = item.type;
        if (code === 'Slide') {
          code = 'LeftOut'
        }
        if (code === 'None') {
          end = start;
        } else {
          if(start >= this.SelectScenes_Msg.duration) {
            start = this.SelectScenes_Msg.duration - 500;
          }
          end = Math.min(start + 500, this.SelectScenes_Msg.duration);
        }

        undoData.data.push({
          id: s.id,
          data: {
            exitAnim: {
              type: code,
              start: start,
              end: end
            }
          }
        })

        s.updateEffect({
          exitAnim: {
            type: code,
            start,
            end
          }
        })
      }
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
      this.$bus.emit('updateEffect_vue', {
        type: 'exitEffect'
      });
      this.$emit('changeData')
    },
    setEasing(item) {
      if(item.active) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      this.easingList.forEach(v => {
            v.active = false;
      })
      item.active = true;
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        undoData.reData.push({
          id: s.id,
          data: {
            exitAnim: {
              easing: s.effect.exitAnim.easing
            }
          }
        })
        undoData.data.push({
          id: s.id,
          data: {
            exitAnim: {
              easing: item.alias
            }
          }
        })
        s.updateEffect({
          exitAnim: {
            easing: item.alias
          }
        })
      }
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
    },
    selectEffect(item) {
      if(item.active) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      this.showList.forEach(v => {
            v.active = false;
      })
      item.active = true;
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let data = {}
        undoData.reData.push({
          id: s.id,
          data: {
            exitAnim: {
              type: s.effect.exitAnim.type,
              direction: s.effect.exitAnim.direction
            }
          }
        })
        if(this.type === 'Slide') {
          data.type = item.type;
        } else {
          data.direction = item.direction;
        }
        undoData.data.push({
          id: s.id,
          data: {
            exitAnim: data
          }
        })
        s.updateEffect({
          exitAnim: data
        })
      }
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
    },
    showHand() {
      if(!this.hasHand) return;
      this.$bus.emit('Modal_vue', {
        name: 'hand',
        type: 'hand',
        data: {
          inout: 'out',
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.exit-effect {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.exit-effect-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
.exit-effect-content{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  > div {
    text-align: center;
    font-size: 13px;
    margin-right: 12px;
    margin-bottom: 13px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  .effect-select {
    margin: 0 auto;
    width: 46px;
    height: 46px;
    background-color: #f0f0f8;
    border-radius: 4px;
    margin-bottom: 7px;
    line-height: 60px;
    text-align: center;
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;
  }

  .effect-select.active {
    border-color: #5778fb;
  }

  .is-short {
    display: inline-block;
    width: 42px;
    height: 42px;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .icon-noAnim-anim {
    position: relative;
    right: -50%;
    background: #FF293D;
    width: 2px;
    height: 102%;
    display: block;
    transform: skew(-45deg);
  }
}

.radios {
  margin-bottom: 13px;

  &__title {
    color: #474261;
    margin-bottom: 13px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    width: 180px;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #9692a9;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #9692a9;
      box-shadow: 0 0 0 2px #ffffff inset;
    }
  }
}

.list {

  &__title {
    color: #474261;
    margin-bottom: 13px;
    text-align-last: left;
  }

  & > ul {
    display: flex;
  }
  &__items {
    justify-content: space-between;
  }
  &__item {
    margin-right: 6px;
    margin-bottom: 15px;
    cursor: pointer;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &.active .list__figure {
      border-color: #5778fb;
      background-color: #D9DDEA;
    }
  }
  &__figure {
    width: 46px;
    height: 46px;
    background-color: #f0f0f8;
    border: 2px solid transparent;
    border-radius: 4px;
    overflow: hidden;
  }
  &__caption {
    margin-top: 7px;
  }
}

.list .list__item .list__figure >.icon {
  width: 44px;
  height: 44px;
}

.hand {
  margin-bottom: 15px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #D9DDEA;
  border-radius: 4px;
  cursor: pointer;

  &.disable {
    opacity: .6;
    cursor: not-allowed;
  }

  i {
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }

  &:hover:not(.disable) {
    border-color: #5778FB;
  }
}
.icon-slide-anim {
  background-image: url('../../../static/animengine/img/icon-effect-right-out.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-right-out.gif');
  }
}
.icon-pop-anim {
  background-image: url('../../../static/animengine/img/icon-effect-pop-out.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-pop-out.gif');
  }
}
.icon-fade-anim {
  background-image: url('../../../static/animengine/img/icon-effect-fade-out.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-fade-out.gif');
  }
}
.icon-smear-anim {
  background-image: url('../../../static/animengine/img/icon-effect-smear-e-out.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-smear-e-out.gif');
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/exitEffect.vue